import React, { useState } from "react";
import { motion } from "framer-motion";

const faqData = [
  { question: "What is MonadScore and how does it power NTB?", answer: "MonadScore is the intelligence engine behind NTB. It analyzes liquidity, transaction patterns, and token safety in real time, helping NTB optimize every swap and protect users." },
  { question: "How does NTB choose where to trade?", answer: "It aggregates liquidity across multiple Monad DEXs and uses MonadScore data to find the best route for every trade." },
  { question: "Can I customize how NTB trades?", answer: "Yes. Configure auto-buy, slippage, and priority settings, all inside Telegram." },
  { question: "Which tokens can I trade?", answer: "Any token with liquidity on Monad DEXs." },
  { question: "What are the fees?", answer: "Flat 0.6 percent per trade, transparent and fair." },
  { question: "Is my wallet safe?", answer: "Yes. Wallets are encrypted, non-custodial, and stored locally." },
  { question: "How does NTB stay so fast?", answer: "Built natively on Monad, with optimized gas, low latency, and predictive routing." },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq"  className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12">FAQ</h2>

      <motion.div
        className="max-w-4xl mx-auto bg-white/10 rounded-xl p-6 space-y-4"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        {faqData.map((item, index) => (
          <motion.div
            key={index}
            className="bg-white/10 rounded-lg p-4 cursor-pointer flex flex-col sm:flex-row justify-between items-start sm:items-center"
            onClick={() => toggleIndex(index)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <div className="mb-2 sm:mb-0">
              <h3 className="text-lg sm:text-xl font-semibold">{item.question}</h3>
              {openIndex === index && (
                <p className="mt-2 text-gray-200">{item.answer}</p>
              )}
            </div>
            <div className="w-8 h-8 rounded-full bg-[#313131] text-white flex items-center justify-center font-bold">
              {openIndex === index ? "-" : "+"}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default FAQ;